import React from "react";

import { Surface } from "@lattice/frontend/components/kit/Surface";

export function SettingsPanelLoading({ label }: { label: string }) {
  return (
    <Surface tone="subtle">
      <div aria-label={label} className="shell-settings-state" role="status">
        <span aria-hidden className="lk-spinner" />
        <span>{label}</span>
      </div>
    </Surface>
  );
}

export function SettingsPanelError({ message }: { message: string }) {
  return (
    <Surface tone="subtle">
      <p
        className="shell-settings-state shell-settings-state--error"
        role="alert"
      >
        {message}
      </p>
    </Surface>
  );
}

export function SettingsPanelSuccess({ message }: { message: string }) {
  return (
    <p
      className="shell-settings-state shell-settings-state--success"
      role="status"
    >
      {message}
    </p>
  );
}

export function SettingsSection({
  action,
  children,
  label,
}: {
  action?: React.ReactNode;
  children: React.ReactNode;
  label: string;
}) {
  return (
    <section className="shell-settings-section">
      <div className="shell-settings-section__header">
        <h2 className="shell-settings-section__label">{label}</h2>
        {action}
      </div>
      {children}
    </section>
  );
}
